"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.InputSwitchComponent = void 0;
var _CheckboxComponent = _interopRequireDefault(require("./CheckboxComponent"));
var _IntegerSelectorComponent = _interopRequireDefault(require("./IntegerSelectorComponent"));
var _RadioComponent = _interopRequireDefault(require("./RadioComponent"));
var _DomainSearchComponent = _interopRequireDefault(require("./DomainSearchComponent"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _react = require("react");
var _storeProvider = require("./../util/storeProvider");
var _common = require("./../util/common");
var _PriceOverrideComponent = _interopRequireDefault(require("./PriceOverrideComponent"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
class InputSwitchComponent extends _react.PureComponent {
  constructor(props) {
    super(props);
  }
  render() {
    const {
      enumVal,
      layoutProperties: {
        display
      },
      type,
      includeState
    } = this.props;
    const {
      store,
      postComplete
    } = this.context;
    const disabled = !postComplete;
    if (display === 'noinput') {
      return null;
    } else if (display === 'domainSearch') {
      return /*#__PURE__*/React.createElement(_DomainSearchComponent.default, _extends({
        disabled: disabled
      }, this.props, {
        includeState: [{
          path: 'app.content',
          propKey: 'commonContent'
        }, {
          path: 'domainSearch',
          propKey: 'domainSearch'
        }, ...includeState]
      }));
    } else if (display === 'checkbox' || type === 'boolean') {
      return /*#__PURE__*/React.createElement(_CheckboxComponent.default, _extends({
        disabled: disabled
      }, this.props));
    } else if (display === 'radio' || display === 'termSelector') {
      return /*#__PURE__*/React.createElement(_RadioComponent.default, _extends({}, this.props, {
        includeState: [{
          path: 'app.content',
          propKey: 'commonContent'
        }, ...includeState],
        disabled: disabled
      }));
    } else if (display === 'integer' || (type === 'integer' || type === 'number') && enumVal) {
      const quantityInstancePath = (0, _common.convertToQuantityInstancePath)(this.props.instancePath);
      const {
        min,
        max
      } = store.getDataByInstancePath(quantityInstancePath);
      const qtyVal = store.getInstanceByInstancePath(quantityInstancePath);
      return /*#__PURE__*/React.createElement(_IntegerSelectorComponent.default, _extends({
        min: min,
        max: max,
        disabled: disabled
      }, this.props, {
        instancePath: quantityInstancePath,
        selectedVal: qtyVal
      }));
    } else if (display === 'priceOverride') {
      return /*#__PURE__*/React.createElement(_PriceOverrideComponent.default, _extends({
        selectedVal: this.props.selectedVal,
        instancePath: this.props.instancePath,
        layoutProperties: this.props.layoutProperties
      }, this.props, {
        includeState: [{
          path: 'app.content',
          propKey: 'commonContent'
        }, ...includeState],
        content: this.props.content,
        maxPricePerMonthFormatted: this.props.maxPricePerMonthFormatted,
        minPricePerMonthFormatted: this.props.minPricePerMonthFormatted
      }));
    }
    return null; // Ideally this should never happen
  }
}
exports.InputSwitchComponent = InputSwitchComponent;
InputSwitchComponent.propTypes = {
  type: _propTypes.default.string,
  enumVal: _propTypes.default.oneOfType([_propTypes.default.bool, _propTypes.default.string, _propTypes.default.number]),
  defaultVal: _propTypes.default.oneOfType([_propTypes.default.bool, _propTypes.default.string, _propTypes.default.number]),
  instancePath: _propTypes.default.string,
  layoutProperties: _propTypes.default.object,
  includeState: _propTypes.default.array,
  content: _propTypes.default.object,
  price: _propTypes.default.object,
  selectedVal: _propTypes.default.oneOfType([_propTypes.default.object, _propTypes.default.bool, _propTypes.default.string, _propTypes.default.number]),
  maxPricePerMonthFormatted: _propTypes.default.string,
  minPricePerMonthFormatted: _propTypes.default.string
};
var _default = exports.default = (0, _storeProvider.provideContext)(InputSwitchComponent);